import * as constants from './constants';
import { actionTypes } from '../constants';

// Actions

const setDateIntervalAction = (dateInterval) => {
	return {
		type: constants.SET_DATE_INTERVAL,
		dateInterval
	};
};

// Action Creators
export const getBulkUploadStatusRequest = (assetId, from, to) => ({
	type: actionTypes.GET_BULK_UPLOAD_STATUS_REQUEST,
	assetId,
	startDate: from,
	endDate: to,
});

export const setDateInterval = dateInterval => {
	return dispatch => {
		dispatch(setDateIntervalAction(dateInterval));
	};
};
